import React from 'react';
import PropTypes from 'prop-types';
/* Utils */
import { getStaticImageUrl } from 'client/utils/image-helpers';

function iconWithText(info) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: ' flex-start ',
        fontSize: '0.875rem',
      }}
    >
      <div
        style={{
          marginBottom: '4px',
        }}
      >
        <img src={getStaticImageUrl(info.icon)} alt="" loading="lazy" width={info.width} height={info.height} />
      </div>
      <div
        style={{
          display: 'flex',
          color: '#2a3546',
          fontWeight: '400',
        }}
      >
        <div>{info.text}&nbsp;</div>
      </div>
    </div>
  );
}
export function CaramelBenefits({ benefits = [] }) {
  return (
    <ul
      style={{
        display: 'flex',
        width: ' 100%',
        justifyContent: 'space-between',
        marginBottom: '1rem',
        marginTop: '0.5rem',
        listStyle: 'none',
        padding: '0',
      }}
    >
      {benefits.map((info, index) => (
        <li key={`entry-point-icon_${index + 1}`}>{iconWithText(info)}</li>
      ))}
    </ul>
  );
}

CaramelBenefits.propTypes = {
  benefits: PropTypes.arrayOf(PropTypes.shape({})),
};
